export const FollowUser = async (userId: string) =>
  fetch('/api/secure/social/follow-user', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userId),
  }).then((e) => e.json());

export const UnfollowUser = async (userId: string) =>
  fetch('/api/secure/social/follow-user', {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userId),
  }).then((e) => e.json());

export const LikeToken = async (tokenId: string) =>
  fetch('/api/secure/social/like-token', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(tokenId),
  }).then((e) => e.json());

export const UnlikeToken = async (tokenId: string) =>
  fetch('/api/secure/social/like-token', {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(tokenId),
  }).then((e) => e.json());

export const UserLikesToken = async (userid: string, tokenid: string) =>
  fetch(`/api/public/social/${userid}/likes-token/${tokenid}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());

/* user follows board */
export const FollowBoard = async (encodedId: string) =>
  fetch(`/api/secure/boards/${encodedId}/follow`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());

/* user unfollows board */
export const UnfollowBoard = async (encodedId: string) =>
  fetch(`/api/secure/boards/${encodedId}/unfollow`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());

export const UserFollowsBoard = async (userid: string, encodedId: string) =>
  fetch(`/api/public/user/${userid}/boards/${encodedId}/follows`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((e) => e.json());
